import { usePermissions } from "@/modules/auth/presentation/model/usePermissions";
import { Button } from "@/components/ui/button";

import { useNavigate } from "@tanstack/react-router";
import { PackagePlusIcon } from "lucide-react";

export function LotsToolbar() {
  const { has } = usePermissions();
  const nav = useNavigate({ from: "/app/inventory/lots" });

  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="flex flex-col">
          <h2 className="font-bold text-2xl tracking-tight">
            ລາຍການ Lot (ສາງ)
          </h2>
          <p className="text-muted-foreground">
            ເບິ່ງ lot ຕາມສາຂາ ແລະ ວັດຖຸດິບ, ຮຽງຕາມ FEFO ຫຼື FIFO.
          </p>
        </div>
        {has("inventory:update") && (
          <Button
            onClick={() => nav({ to: "/app/inventory/lots/receive" })}
            className="gap-2"
          >
            <PackagePlusIcon className="size-4" />
            ຮັບເຂົ້າ Lot
          </Button>
        )}
      </div>
    </div>
  );
}
